import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalRef } from './modal-ref';

export class RiberaModalRef<T = unknown> extends ModalRef<T> {

  private ref!: DynamicDialogRef;

  attach(ref: DynamicDialogRef) {
    this.ref = ref;
  }

  close(result?: T): void {
    this.ref.close(result);
  }
}
